// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"b34fdeb525a93526","5691":"1ddf7cd581aa358d"}[chunkId] + ".css";
};